import moment from "moment";
import logger from "../utils/logger";
import { COMMERCIAL_PARTNER_IKAT, COMMERCIAL_PARTNER_RT_EXCEPTION } from "../constants/common";

export async function listOfEmployeesByClient(clientId) {
    if (!clientId || clientId === "all") {
        return listOfEmployees();
    }
    try {
        let _q = `SELECT c.* FROM consultant AS c \
            LEFT JOIN project AS p ON c.uuid = p.uuid AND p.active = true \
            LEFT JOIN project_master AS pm ON p.pid = pm.pid \
            WHERE pm.cid = '${clientId}' AND c.entity = 'MTINC'`;
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["consultant"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("listOfEmployeesByClient failed", { clientId }, error);
        return [];
    }
}

export async function listOfEmployeesByVendor(vendor) {
    if (!vendor || vendor === "all") {
        return listOfEmployees();
    }
    try {
        let _q = `SELECT c.* FROM consultant AS c \
            LEFT JOIN project AS p ON c.uuid = p.uuid AND p.active = true \
            LEFT JOIN project_master AS pm ON p.pid = pm.pid \
            WHERE pm.vendor = '${vendor}' AND c.entity = 'MTINC'`;
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["consultant"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("listOfEmployeesByVendor failed", { vendor }, error);
        return [];
    }
}

export async function addUpdateConsultant(consultantData) {
    console.log(consultantData);
    try {
        const rawResponse = await fetch(process.env.REACT_APP_API_URL + "/api/consultant", {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(consultantData),
        });
        const content = await rawResponse.json();
        return content;
    } catch (error) {
        logger.error("addUpdateConsultant failed", { consultantData }, error);
        return null;
    }
}
export async function DeactivateActivateConsultant(uuid: any, active: number) {
    console.log(uuid);
    let _q = "UPDATE consultant SET  `active`=" + active + " where uuid='" + uuid + "'";
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["consultant"],
            }),
        });

        if (active === 0) {
            try {
                const updateProjectQuery =
                    "UPDATE project SET end_dt = NOW() WHERE uuid = '" + uuid + "' AND active = true AND end_dt > NOW()";
                await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        query: updateProjectQuery,
                        params: ["project"],
                    }),
                });
            } catch (projErr) {
                logger.error('Failed to update project end dates on deactivation', { uuid, active }, projErr);
            }
        }

        return await response.json();
    } catch (error) {
        logger.error("DeactivateActivateConsultant failed", { uuid, active }, error);
        return [];
    }
}

export async function listOfEmployees() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "SELECT * FROM consultant order by name;",
                params: ["consultant"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("listOfEmployees failed", {}, error);
        return [];
    }
}

export async function listIkatEmployees() {
    try {
        let _q = "SELECT c.uuid AS uuid, p.uuid AS project_uuid, pm.pid AS project_master_pid, c.name as name,cm.name as client,c.name as  cname,pm.name AS project,p.*,pm.*, cm.*,c.* FROM consultant AS c LEFT JOIN project AS p ON c.uuid = p.uuid AND p.active = true LEFT JOIN project_master AS pm  ON p.pid = pm.pid LEFT JOIN client_master as cm ON pm.cid = cm.id";
        _q += " where p.ikat_rate IS NOT NULL and p.ikat_rate > 0 ORDER BY c.name ASC";
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["consultant"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("listIkatEmployees failed", {}, error);
        return [];
    }
}

export async function listRtEmployees() {
    try {
        let _q = "SELECT c.uuid AS uuid, p.uuid AS project_uuid, pm.pid AS project_master_pid, c.name as name,cm.name as client,c.name as  cname,pm.name AS project,p.*,pm.*, cm.*,c.* FROM consultant AS c LEFT JOIN project AS p ON c.uuid = p.uuid AND p.active = true LEFT JOIN project_master AS pm  ON p.pid = pm.pid LEFT JOIN client_master as cm ON pm.cid = cm.id";
        // RT exception mappings have no RT rate and bill on the normal project rate.
        // Mirrors the RT report scope: explicit RT or untagged-with-RT-rate, never IKAT.
        const notIkat = `LOWER(COALESCE(p.commercial_partner, '')) <> '${COMMERCIAL_PARTNER_IKAT.toLowerCase()}'`;
        const isRtException = `LOWER(COALESCE(p.commercial_partner, '')) = '${COMMERCIAL_PARTNER_RT_EXCEPTION.toLowerCase()}'`;
        _q += " where ((p.rt_rate IS NOT NULL and p.rt_rate > 0 and " + notIkat + ") or (" + isRtException + " and p.rate IS NOT NULL and p.rate > 0)) ORDER BY c.name ASC";
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["consultant"],
            }),
        });
        const rows = await response.json();
        // A failed query returns {"error": ...}; never hand that to a .map() in the UI.
        return Array.isArray(rows) ? rows : [];
    } catch (error) {
        logger.error("listRtEmployees failed", {}, error);
        return [];
    }
}

export async function listOfEmployeesValidPaystub(filters: any) {
    let _q = "SELECT c.uuid AS uuid, p.uuid AS project_uuid, pm.pid AS project_master_pid, c.name as name,cm.name as client,c.name as  cname,pm.name AS project,p.*,pm.*, cm.*,c.* FROM consultant AS c LEFT JOIN project AS p ON c.uuid = p.uuid AND p.active = true LEFT JOIN project_master AS pm  ON p.pid = pm.pid LEFT JOIN client_master as cm ON pm.cid = cm.id";

    if (filters.activeStatus > 0) {
        _q += " and c.active = " + filters.activeStatus + " ";
    }

    _q += "and c.unstructured is not null and c.entity = 'MTINC'  ";

    _q += " where 1=1  ";

    
    _q += " and c.payroll_process = 1 and c.entity = 'MTINC' ";
    if (filters.activeStatus > 0) {
        _q += " and c.active = " + filters.activeStatus + " ";
    }
    _q += " GROUP BY c.uuid, c.name order by c.name ";

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["consultant"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("listOfEmployeesValidPaystub failed", { filters }, error);
        return [];
    }
}

export async function getFilteredEmployees(filters: any) {
    console.log(filters);

    let _q = "SELECT c.uuid AS uuid, p.uuid AS project_uuid, pm.pid AS project_master_pid, c.name as name,cm.name as client,c.name as  cname,pm.name AS project,p.*,pm.*, cm.*,c.* FROM consultant AS c LEFT JOIN project AS p ON c.uuid = p.uuid AND p.active = true LEFT JOIN project_master AS pm  ON p.pid = pm.pid LEFT JOIN client_master as cm ON pm.cid = cm.id";
    _q += " where 1=1 ";

    _q += " and c.entity='MTINC' ";

    if (filters.activeStatus >= 0) {
        _q += "  and c.active = " + filters.activeStatus + "";
    }
    _q += " GROUP BY c.uuid, c.name order by c.name ";
    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["consultant"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("getFilteredEmployees failed", { filters }, error);
        return [];
    }
}

export function getName(list: any, uuid: any) {
    if (list.length > 0) {
        return list.filter((v) => v.uuid === uuid)[0].name;
    } else {
        return uuid;
    }
}

export function getEmployeeRecord(list: any, uuid: any) {
    if (list.length > 0) {
        return list.filter((v) => v.uuid === uuid)[0];
    } else {
        return uuid;
    }
}

export async function getProfile(uuid: any) {
    try {
        let _q = "SELECT c.uuid AS uuid, p.uuid AS project_uuid, c.fixed_payroll, pm.pid AS project_master_pid, c.name as name,cm.name as client,c.name as  cname,pm.name AS project,p.*,pm.*, cm.*,c.* FROM consultant AS c LEFT JOIN project AS p ON c.uuid = p.uuid AND p.active = true LEFT JOIN project_master AS pm  ON p.pid = pm.pid LEFT JOIN client_master as cm ON pm.cid = cm.id";
        if (uuid) {
            _q += " where  c.uuid = '" + uuid + "'";
        }
        console.log(_q);
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["consultant"],
            }),
        });
        if (!response.ok) { 
            logger.error("getProfile response error:", { status: response.status });
            return [];
        }
        return await response.json();
    } catch (error) {
        logger.error("getProfile failed", { uuid }, error);
        return [];
    }
}

export async function getProfileByUUID(uuid: any) {
    console.log(uuid);
    let _q = "SELECT c.uuid AS uuid, p.uuid AS project_uuid, pm.pid AS project_master_pid, c.name as name,cm.name as client,c.name as  cname,pm.name AS project,p.*,pm.*, cm.*,c.* FROM consultant AS c LEFT JOIN project AS p ON c.uuid = p.uuid AND p.active = true LEFT JOIN project_master AS pm  ON p.pid = pm.pid LEFT JOIN client_master as cm ON pm.cid = cm.id";
    if (uuid) {
        _q += " where  c.uuid = '" + uuid + "'";
    }
    console.log(_q);
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["consultant"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("getProfileByUUID failed", { uuid }, error);
        return [];
    }
}

export async function getConsultantDetails(uuid: any) {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/consultant_details?_where=(uuid,eq," + uuid + ")~and(active,eq,1)&_sort=type,sub_type");
        return await response.json();
    } catch (error) {
        logger.error("getConsultantDetails failed", { uuid }, error);
        return [];
    }
}
